<template>
  <div class="textures">
    <div class="texture" v-for="(texture, indx) in textures" :id="texture.id" :key="indx"
         v-on:click="loadTexture(indx)"
         :class="{'active':selectedTextureIndex === indx}" :data-qrcode="texture.qrcode">
      <span><img width="100%" :src="texture.icon" alt=""></span>
    </div>
  </div>

</template>

<script>
import {mapState} from "vuex";
import {isEqual} from "lodash";

export default {
  name: 'Textures',
  props: {
    mask: Object,
  },
  data() {
    return {
      ...mapState([
        "currentMask"
      ]),
      textures: [],
      selectedTextureIndex: 0,
    }
  },

  methods: {
    loadTexture(index = 0) {
      this.selectedTextureIndex = index;

      let maskObject = this.currentMask.object ? this.currentMask.object : this.currentMask.name.toLowerCase();

      if (this.currentMask.textures[index]) {
        if (this.currentMask.textures[index].url_object.includes('png')) {
          load_mask(maskObject, this.currentMask.textures[index].url_object);
        } else {
          load_mask(this.currentMask.textures[index].url_object);
        }
      }
    },
  },
  watch: {
    mask: function (newVal, oldVal) { // watch it
      if (!isEqual(newVal, oldVal)) {
        this.currentMask = newVal;
        this.textures = [...newVal.textures];
      } else {
        this.currentMask = oldVal;
        this.textures = [...oldVal.textures];
      }
      //reset previous render
      this.selectedTextureIndex = 0;
      let maskObject = this.currentMask.object ? this.currentMask.object : this.currentMask.name.toLowerCase();

      if (this.currentMask.textures[this.selectedTextureIndex]) {
        if (this.currentMask.textures[this.selectedTextureIndex].url_object.includes('png') || this.currentMask.textures[this.selectedTextureIndex].url_object.includes('jpg')) {
          load_mask(maskObject, this.currentMask.textures[this.selectedTextureIndex].url_object);
        } else {
          load_mask(this.currentMask.textures[this.selectedTextureIndex].url_object);
        }
      }
    }
  },
  mounted() {
    setTimeout(() => { this.loadTexture() },900)
  }
}

</script>

<style scoped>

.textures {
  position: absolute;
  display: flex;
  left: 5px;
  top: -20px;
  color: #fff;
}

.textures > * {
  margin: 0 5px;
}

.active {
  border: 2px solid #00d6ff;
}

.texture {
  border-radius: 50%;
  text-align: center;
  line-height: 26px;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, .5);
  font-weight: bold;
}

.texture img {
  border-radius: 50%;
}


</style>
